import React, { useState } from "react";
import { VideoPlayerModel } from "./models/VideoPlayer.model";
import { VideoPlayerProps } from "./types/VideoPlayer.types";
import Youtube from "./Youtube";
import Vimeo from "./Vimeo";
import Custom from "./Custom";

import "./styles.scss";
import { Image, RichText, Text } from "@sitecore-jss/sitecore-jss-react";

import Modal from "./Modal";
import LazySection from "../../react-only-components/LazySection";

const VideoPlayer = (props: VideoPlayerProps) => {
  const model = new VideoPlayerModel(props);
  const [modalIsOpen, setIsOpen] = useState(false);

  const getYoutubeUrl = () => {
    return (
      model.url?.value?.href +
      `?controls=1&enablejsapi=1&autoplay=${
        model.autoPlay?.value ? 1 : 0
      }&mute=${model.autoPlay?.value ? (visibility ? 0 : 1) : 0}`
    );
  };

  const getRawYoutubeUrl = () => {
    return model.url?.value?.href + `?controls=1&enablejsapi=1`;
  };

  const getYimeoUrl = () => {
    return (
      model.url?.value?.href +
      `?&dnt=1&autoplay=${model.autoPlay?.value ? 1 : 0}&muted=${
        model.autoPlay?.value ? (visibility ? 0 : 1) : 0
      }`
    );
  };
  const getRawYimeoUrl = () => {
    return model.url?.value?.href + `?&dnt=1`;
  };

  const getCustomeUrl = () => {
    return model.url?.value?.href;
    //return   window.location?.protocol + `//` + window.location?.host + "/" + model.url.value.href;
  };

  const getPreviewUrl = () => {
    //return   window.location?.protocol + `//` + window.location?.host + "/" + model.splashImage.value.src;
    //return model.splashImage.value.src;
    return model.splashImage;
  };

  const getMediaPreviewUrl = () => {
    //return   window.location?.protocol + `//` + window.location?.host + "/" + model.splashImage.value.src;
    return model.splashImage?.value?.src;
  };

  const openModal = () => {
    setVisibility(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const [visibility, setVisibility] = useState(false);

  const popupCloseHandler = (e) => {
    setVisibility(e);
  };

  return (
    <LazySection>
      {visibility && (
        <Modal onClose={popupCloseHandler} show={visibility}>
          <>
            {model?.provider?.value === "Youtube" ? (
              <Youtube
                url={getYoutubeUrl()}
                rawUrl={getRawYoutubeUrl()}
                //shownInsideModal={visibility}
                //openFromModal={true}
                previewUrl={getPreviewUrl()}
                autoplay={model.autoPlay?.value}
              ></Youtube>
            ) : model?.provider?.value === "Vimeo" ? (
              <Vimeo
                url={getYimeoUrl()}
                rawUrl={getRawYimeoUrl()}
                //openFromModal={true}
                //shownInsideModal={visibility}
                previewUrl={getPreviewUrl()}
                autoplay={model.autoPlay?.value}
              ></Vimeo>
            ) : model?.provider?.value === "Media" ? (
              <Custom
                url={getCustomeUrl()}
                // openFromModal={true}
                visibility={visibility}
                autoplay={model.autoPlay?.value}
                previewUrl={getMediaPreviewUrl()}
              ></Custom>
            ) : null}
          </>
        </Modal>
      )}

      {props?.params?.["Playing Target"] === "Overlay" ? (
        <div className="player_overlay">
          <div className="player_image_wrapper">
            <Image field={model?.splashImage} />
          </div>
          <div className="player_content">
            <Text tag="h2" field={model?.title} />
            <RichText tag="p" field={model?.description} />
            <div
              className="cta cta-primary cta-primary-red"
              onClick={(e) => {
                e.preventDefault();
                openModal();
              }}
            >
              <Text tag="a" field={model?.cta} />
            </div>
          </div>
        </div>
      ) : (
        <div className="player_wrapper embedded">
          <div className="content-wrapper">
            <Text tag="h2" field={model?.title} />
            <RichText tag="p" field={model?.description} />
          </div>
          {model?.provider?.value === "Youtube" ? (
            <Youtube
              rawUrl={getRawYoutubeUrl()}
              url={getYoutubeUrl()}
              previewUrl={getPreviewUrl()}
              autoplay={model.autoPlay?.value}
            ></Youtube>
          ) : model?.provider?.value === "Vimeo" ? (
            <Vimeo
              rawUrl={getRawYimeoUrl()}
              url={getYimeoUrl()}
              previewUrl={getPreviewUrl()}
              autoplay={model.autoPlay?.value}
            ></Vimeo>
          ) : model?.provider?.value === "Media" ? (
            <Custom
              url={getCustomeUrl()}
              autoplay={model.autoPlay?.value}
              previewUrl={getMediaPreviewUrl()}
            ></Custom>
          ) : null}
        </div>
      )}
    </LazySection>
  );
};

export default VideoPlayer;
